import { RequestModelInterface } from "@/service/models/request-model-interface";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { DrugSample } from "./drug-sample";
import { DrugTarget } from "./drug-target";
import { DrugTreatment } from "./drug-treatment";

export class Drug implements RequestModelInterface
{
    public samples: DrugSample[] = [];
    public targets: DrugTarget[] = [];

    public constructor(
        public id: string,
        public activePrinciple: string,
        public brandName: string,
        public atc: string,
        public treatment: DrugTreatment,
    )
    {
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("drug");

        element.appendNewElement("drugId", this.id);
        element.appendNewElement("activePrinciple", this.activePrinciple);
        element.appendNewElement("brandName", this.brandName);
        element.appendNewElement("atc", this.atc);

        element.append(this.treatment.getXml(doc));

        if (this.samples.length > 0) {
            element.appendNewElement("samples").appendChildren(this.samples);
        }

        if (this.targets.length > 0) {
            element.appendNewElement("targets").appendChildren(this.targets);
        }

        return element;
    }
}
